<template>
  <div class="cotton-project-selection" :style="showAsideBtnClass">
    <el-container>
      <el-header>
        <div class="left">
          <img src="/static/image/cotton/category.png" alt="" srcset="" />
          <span>{{ $t('场地分类') }}</span>
        </div>
        <div class="right">
          <el-input v-model="queryModel.name" :placeholder="$t('请输入堆场名称')">
            <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
          </el-input>
        </div>
      </el-header>
      <el-container>
        <el-aside v-if="showAside">
          <div class="categories">
            <div
              v-for="item in categories"
              :key="item.label"
              @click="queryModel.type = item.type"
              :class="{ active: queryModel.type === item.type }"
            >
              {{ item.label }}
            </div>
          </div>
        </el-aside>
        <el-main>
          <div
            class="project-item"
            v-for="(item, index) in deptList"
            :class="{
              active: activeDept === item.id,
              'is-alarm': deptStateMap[item.id] && deptStateMap[item.id].isAlarm
            }"
            @click="handleClick(item)"
            :key="item.id"
          >
            <!-- <el-tooltip
              class="item"
              effect="dark"
              :content="`${index + 1}.${item.name}`"
              placement="top"
            > -->
            <span>{{ index + 1 }}.{{ item.name }}</span>
            <!-- </el-tooltip> -->
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { officeTypeDict } from '@/utils/const/office';
import { getStateHighLevelOptionBy } from '@/utils/deviceUtils/state';
import { mapState } from 'vuex';
import { List } from '@/utils/List';
import { isEmpty } from '@/utils/is';

export default {
  data() {
    return {
      categories: [
        { label: '堆场', type: 4 },
        { label: '轧花厂', type: 3 }
      ],
      activeDept: '',
      queryModel: {
        type: 4,
        name: ''
      },
      showAside: true
    };
  },
  computed: {
    ...mapState('socket', ['deviceTree']),
    showAsideBtnClass() {
      return {
        '--main-padding-left': this.showAside ? '0px' : '3%',
        '--aside-btn-width': this.showAside ? 'var(--aside-left)' : '0px'
      };
    },
    cottonDeptList() {
      if (isEmpty(this.deviceTree)) return [];

      return this.deviceTree.filter(e => {
        return [4, 3].includes(+e.type);
      });
    },
    deptList() {
      const res = this.cottonDeptList.filter(e => {
        return +e.type === this.queryModel.type && e.name.indexOf(this.queryModel.name) !== -1;
      });

      return res;
    },
    deptStateMap() {
      const map = {};

      this.cottonDeptList.forEach(e => {
        map[e.id] = getStateHighLevelOptionBy(e.children, { useLevel2: true });
      });

      return map;
    }
  },
  methods: {
    handleSearch() {},
    handleClick(item) {
      const name = officeTypeDict.getOptionByKey(item.type).routeName;

      this.$router.push({
        name,
        params: {
          id: item.id
        }
      });
    },
    initHandle() {
      const map = new List(this.cottonDeptList).groupBy('type');

      const li = map.list.filter(e => e.items.length > 0);

      if (li.length != 1) return;

      this.showAside = false;
      this.queryModel.type = +li[0].key;

      const items = li[0].items;

      if (items.length === 1) {
        setTimeout(() => {
          this.handleClick(items[0]);
        }, 500);
      }
    }
  },
  // mounted() {
  //   this.initHandle();
  // },
  watch: {
    cottonDeptList: {
      handler: 'initHandle',
      immediate: true
    }
  }
};
</script>

<style lang="scss">
.cotton-project-selection {
  padding: 46px;
  background: var(--cotton-ps-bg);
  box-sizing: border-box;
  height: 100%;
  overflow: hidden;

  --aside-left: 323px;
  --aside-btn-width: var(--aside-left);
  --main-padding-left: 0px;
  --header-height: 90px;

  & > .el-container {
    height: 100%;

    padding: 29px 0;

    background: var(--cotton-ps-container-bg);

    border: 2px solid var(--cotton-ps-container-border);
    border-radius: 20px;
    position: relative;
    overflow: hidden;

    &::after {
      content: ' ';
      box-shadow: inset 0 0 30px 30px var(--cotton-ps-container-shadow);
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
    }

    .el-header {
      display: flex;
      align-items: center;

      height: var(--header-height) !important;
      padding: 0 32px;
      box-sizing: border-box;

      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 500;
      font-size: 40px;
      color: var(--cotton-ps-header-title-color);
      text-align: center;
      font-style: normal;
      text-transform: none;

      overflow: hidden;
      position: relative;

      .right {
        width: calc(100% - var(--aside-left));
        height: 90px;
        display: flex;
        align-items: center;

        .el-input {
          height: 90px;
          background: var(--cotton-ps-container-bg);
          border-radius: 55px 55px 55px 55px;
          border: 2px solid var(--cotton-ps-container-border);

          box-sizing: border-box;

          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 30px;

          overflow: hidden;

          .el-input-group__append {
            width: 168px;
            border-radius: 55px 55px 55px 55px;
            background: var(--cotton-ps-container-border);
            color: var(--cotton-ps-search-btn-text);

            cursor: pointer;

            .el-icon-search {
              font-weight: bold;
              font-size: 38px;
            }
          }

          .el-input__inner {
            background: unset;
            border: unset;
            height: 100%;

            padding: 0 0 0 40px;

            &::placeholder {
              color: var(--cotton-ps-placeholder-color);
            }
          }
        }
      }

      .left {
        width: var(--aside-left);
        height: 90px;
        display: flex;
        align-items: center;
        gap: 5px;

        img {
          width: 46px;
          height: 46px;
        }
      }
    }

    .el-container {
      height: calc(100% - var(--header-height));
      padding: 0 32px;

      .el-aside {
        width: var(--aside-btn-width) !important;

        background: unset;
        border: unset;
        box-shadow: unset;

        .categories {
          display: flex;
          flex-direction: column;

          padding: 0 32px;

          & > div {
            width: 185px;
            height: 70px;
            text-align: center;
            line-height: 70px;

            margin: 22px 0;

            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 500;
            font-size: 30px;

            border-radius: 10px 10px 10px 10px;

            cursor: pointer;

            transition: all 0.3s;

            color: var(--cotton-ps-category-color);

            &:hover {
              color: var(--cotton-ps-category-hover-color);
              background: var(--cotton-ps-category-hover-bg);
            }

            &.active {
              color: var(--cotton-ps-category-active-color);
              background: var(--cotton-ps-category-active-bg);
            }
          }
        }
      }

      .el-main {
        width: calc(100% - var(--aside-btn-width) - 20px);
        height: 100%;
        padding-top: 42px;
        padding-left: var(--main-padding-left);

        display: flex;
        flex-wrap: wrap;
        align-content: baseline;
        gap: 2%;

        .project-item {
          width: 30%;
          height: 86px;
          line-height: 86px;
          background: var(--cotton-ps-item-bg);
          border-radius: 11px 11px 11px 11px;
          border: 2px solid var(--cotton-ps-container-border);

          text-align: center;

          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 30px;
          color: var(--cotton-ps-item-color);

          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          transition: all 0.3s;

          cursor: pointer;

          &.active,
          &:hover {
            background: var(--cotton-ps-item-hover-bg);
          }

          &.is-alarm {
            background: var(--cotton-ps-item-alarm-bg);
          }
        }
      }
    }
  }
}
</style>
